module.exports = __webpack_public_path__ + "static/media/8OLA13.bb01bc46.jpg";